import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({
  name: 'shortScaleNumber'
})
export class ShortScaleNumberPipe implements PipeTransform {
  private decimalPipe: DecimalPipe;

  constructor(@Inject(LOCALE_ID) public locale: string) {
    this.decimalPipe = new DecimalPipe(locale);
  }

  transform(value: number, ...args: unknown[]): string {
    if (value === undefined || value === null || isNaN(value)) {
      return null;
    } else if (value === 0) {
      return '0';
    }

    const fractionSize = 1;
    const rounder = Math.pow(10, fractionSize);
    const isNegative = value < 0;
    const powers = [
      {key: 'B', value: Math.pow(10, 9)},
      {key: 'M', value: Math.pow(10, 6)},
      {key: 'k', value: Math.pow(10, 3)}];
    let abs = Math.floor(Math.abs(value));
    let key = '';

    for (const power of powers) {
      let reduced = abs / power.value;
      reduced = Math.round(reduced * rounder) / rounder;
      if (reduced >= 1) {
        abs = reduced;
        key = power.key;
        break;
      }
    }

    return (isNegative ? '-' : '') + abs + key;
  }
}
